import { NotificationSocketProvider } from '@sit/notifications-client';
import { config } from '@web/config/env';
import { selectToken } from '@web/redux/selectors';
import { useAppSelector } from '@web/redux/store';

export const ConnectedNotificationSocketProvider = ({ children }: { children: React.ReactNode }) => {
  const token = useAppSelector(selectToken);
  return (
    <NotificationSocketProvider token={token} notificationsUrl={config.notificationsUrl}>
      {children}
    </NotificationSocketProvider>
  );
};
